<template>
  <div>
    <div class="header-container">
      <div class="header__wrappper">
        <div class="icon-img">
          <img :src="PackagingIcon" />
        </div>
        <div class="packaging-title__info">
          <div class="packing_scheme_name">
            {{
              formData.evgPackingSchemeName ||
                $l('form_label_addScheme') ||
                '新增方案'
            }}
          </div>
          <div class="d-flex">
            <div>
              <span style="font-size: 14px; color: #606266">
                NO:
                {{
                  formData.evgPackingSchemeNo ||
                    $l('form_label_evgPackingSchemeNoAutoGen') ||
                    '方案编号自动生成'
                }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <el-tag
                size="mini"
                :type="
                  formData.evgPackingSchemeStatus === 'Y'
                    ? 'success'
                    : formData.evgPackingSchemeStatus === 'S'
                    ? 'warning'
                    : formData.evgPackingSchemeStatus === 'D'
                    ? 'danger'
                    : 'primary'
                "
              >
                {{ formData.v_evgPackingSchemeStatus || 'New' }}
              </el-tag>
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 14px; color: #606266">
                Modify: {{ formData.modifyByName || '--' }} at
                {{ formData.modifyDate || '--' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-container">
      <SearchTabs v-model="activeName" :code="newCode" />
      <div v-if="activeName == 'Base'">
        <PackingScheme
          ref="packingSchemeRef"
          :disabled="disabled"
          :evgPackingSchemeCode="newCode"
          @reload="reload"
        ></PackingScheme>
      </div>
      <div v-if="activeName == 'Desc'">
        <OperationDiagram
          :evgPackingSchemeCode="newCode"
          :disabled="disabled"
        ></OperationDiagram>
      </div>
    </div>
  </div>
</template>
<script>
import SearchTabs from '../search-tabs'
import PackingScheme from '../packing-scheme'
import OperationDiagram from '../operation-diagram'
const PackagingIcon = require('./packaging.svg')
export default {
  props: {
    evgPackingSchemeCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { SearchTabs, PackingScheme, OperationDiagram },
  data() {
    return {
      PackagingIcon,
      activeName: 'Base',
      code: '',
      formData: {},
    }
  },
  computed: {
    newCode() {
      return this.evgPackingSchemeCode || this.code
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.newCode) return

      this.$api
        .ecomEvgPackingSchemeDetailApi({
          evgPackingSchemeCode: this.newCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    reload() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.header-container {
  border-radius: 5px;
  height: 84px;
  width: 100%;
  padding: 15px;
  background-color: #ffffff;
  margin-bottom: 10px;
  .header__wrappper {
    display: flex;
    .icon-img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #f4f9ff;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 30px;
        height: 30px;
      }
    }
    .packaging-title__info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .packing_scheme_name {
        color: #101010;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
}
.box-container {
  border-radius: 5px;
  background-color: #ffffff;
  padding: 15px;
}
</style>
